<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  props: ["disabled"],
  data() {
    return {
      observer: null,
      prevPosition: null,
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(([entry]) => {
      const { boundingClientRect, rootBounds } = entry;
      this.prevPosition = entry;

      if (!rootBounds) return;

      const { top: elementTop, bottom: elementBottom } = boundingClientRect;
      const { top: rootTop, bottom: rootBottom } = rootBounds;

      if (elementBottom < rootTop) {
        this.$emit("fullyHidden");
        this.$emit("hideTop");
        return;
      }

      if (elementTop > rootBottom) {
        this.$emit("fullyHidden");
        this.$emit("hideBottom");
        return;
      }

      if (elementTop >= rootTop && elementBottom <= rootBottom) {
        this.$emit("fullyVisible");
        return;
      }

      if (elementTop < rootTop) {
        this.$emit("partiallyHidden");
        this.$emit("crossTop");
      }

      if (elementBottom > rootBottom) {
        this.$emit("partiallyHidden");
        this.$emit("crossBottom");
      }
    });
    this.observer.observe(this.$el, {
      threshold: [0, 1.0],
      root: document.querySelector(".layout"),
    });
  },

  beforeDestroy() {
    this.observer.unobserve(this.$el);
    this.observer.disconnect();
    this.observer = null;
  },

  methods: {
    refresh() {
      this.observer.unobserve(this.$el);
      this.observer.observe(this.$el);
    },
  },
};
</script>
